import styled from 'styled-components';
import { Base } from 'styled';

type StyledPracticeNameProps = {
  typography: 'primary' | 'secondary';
};

export const StyledPracticeName = styled(Base)<StyledPracticeNameProps>`
display: inline;

    ${({ theme, typography }) =>
      typography === 'secondary'
        ? theme.typography.variants.secondary.xs
        : theme.typography.variants.primary.xs};
    }
`;
